<template>
   <div class="crud-wrapper">
      <crud-toolbar
              :modal-mode="modalMode"
              :new-state="newState"
              :title="modalTitle"
              @onCommand="toolbarCommand"
      ></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">
         <v-layout row wrap>
            <a-text-field label="Nome" validate="required" sm6 v-model="formData.name"></a-text-field>
            <a-text-field
                    autofocus
                    label="CPF"
                    sm6
                    v-mask="'###.###.###-##'"
                    v-model="formData.federalId"
                    :disabled="false"
                    validate="required,cpf_cnpj"
            ></a-text-field>
            <a-select-field
                    label="Convênio"
                    obj="covenant"
                    sm4
                    v-model="formData.covenantId"
                    validate="required">
            </a-select-field>
            <a-text-field label="Matrícula/NB" validate="required" v-model="formData.enrollment" sm4></a-text-field>
            <a-text-field label="Número" v-mask="'(##) #####-####'" validate="required" v-model="formData.phone" sm4></a-text-field>
            <a-date-field
                    label="Nascimento"
                    dateFormat="DD/MM/YYYY"
                    v-model="formData.birth"
                    sm4
                    validate="dateDMY"
            ></a-date-field>
            <a-text-field label="Cidade" validate="required" v-model="formData.city" sm6></a-text-field>
            <a-text-field label="Estado" validate="required" v-model="formData.state" sm2></a-text-field>
            <a-text-field label="Cadastrado às" disabled v-model="formatedDate" sm4></a-text-field>
            <v-flex sm8 py-1>
               <v-select label="Situação" :items="situation" v-model="formData.status" sm8 box
                         class="clean-style"></v-select>
            </v-flex>
            <a-text-area-field
                    label="Motivo (aparecerá para o cliente)"
                    v-model="formData.statusToClient"
                    sm12
                    v-show="formData.status == 'P' || formData.status == 'R'"
            ></a-text-area-field>
            <a-text-area-field
                    label="Motivo (uso interno)"
                    v-model="formData.statusNotes"
                    sm12
                    v-show="formData.status == 'P' || formData.status == 'R'"
            ></a-text-area-field>
         </v-layout>

         <template slot="rightContent">
            <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat style="margin-top: -10px; border-radius:12px;">
               <v-card-title>Documentos do Cliente</v-card-title>
               <div class="harpia" v-if="formData.harpia">
                    <div>
                        <p class="harpia-title">Harpia</p>
                        <p class="harpia-description">{{ formData.harpia.description }} ({{ formData.harpia.statusId }})</p>
                    </div>
                    <div class="harpia-substatus" v-for="subStatus in formData.harpia.subStatus" :key="subStatus.subStatusId">
                        <p class="harpia-substatus-description">{{ subStatus.description }} ({{ subStatus.subStatusId }})</p>
                        <div class="harpia-reasons" v-for="reasons in subStatus.reasons" :key="reasons.reasonId">
                            <v-icon class="fas fa-ban" small></v-icon>
                            <div>
                                <p class="harpia-reasons-description">{{ reasons.description }}</p>
                                <p class="harpia-reasons-note">{{ reasons.note }}</p>
                            </div>
                        </div>
                    </div>
               </div>
               <div class="acert" v-if="formData.acert">
                    <div>
                        <p class="acert-title">Acert</p>
                        <p class="acert-description">{{ getAcertStatusName(formData.acert.status) }} ({{ formData.acert.status }})</p>
                    </div>
                    <div class="acert-substatus">
                        <v-icon class="fas fa-ban" small></v-icon>
                        <div>
                            <p class="acert-reason">{{ getAcertReason(formData.acert.status, formData.acert.textReason, formData.acert.reason, formData.acert.biometry) }}</p>
                            <!-- <p class="acert-text-reason">{{  }}</p> -->
                        </div>
                    </div>
               </div>
               <v-card-text v-if="cloudinaryImages.length == 0" class="text-xs-center">Documentos ainda não anexados
               </v-card-text>
               <viewer v-if="cloudinaryImages.length != 0" :images="cloudinaryImages">
                  <img style="max-height:200px; margin: 0px 5px; border-radius:8px;" v-for="src in cloudinaryImages"
                       :src="src" :key="src"/>
               </viewer>
            </v-card>
         </template>
      </crud-form>
   </div>
</template>
<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
    import 'viewerjs/dist/viewer.css';

    export default CrudFormClass.extend({
        name: 'PendingAppUsersForm',

        data () {
            return {
                title: 'Validação Cliente',
                formName: 'pendingAppUserForm',

                situation: [
                    {
                        value: 'B',
                        text: 'Novo'
                    },
                    {
                        value: 'P',
                        text: 'Pendente (Reenviar Doc)'
                    },
                    {
                        value: 'R',
                        text: 'Rejeitado'
                    },
                    {
                        value: 'V',
                        text: 'Validado'
                    }
                ],

                formData: {
                    id: null,
                    covenantName: null,
                    covenantId: null,
                    federalId: null,
                    name: null,
                    birth: null,
                    city: null,
                    state: null,
                    createdAt: null,
                    status: null,
                    file: null,
                    phone: null,
                    statusNotes: null,
                    statusToClient: null,
                    enrollment: null,
                    suspicious: null,
                    harpia: null,
                    acert: null
                }
            };
        },

        watch: {
            'formData.status': function(value) {
                if (value == "P") this.formData.statusToClient = "O sistema recusou os documentos enviados devido à qualidade das imagens. Pedimos que envie novamente tomando o cuidado para estar em um ambiente bem iluminado e sem tremer a mão para tirar as fotos.";
                else this.formData.statusToClient = "";
            }
        },

        computed: {
            formatedDate () {
                return this.$moment(this.formData.createdAt).format('DD/MM/YYYY hh:mm');
            },
            cloudinaryImages () {
                let files = this.formData.file || [];
                return files.map(el => this.$config.imageUri(`${el.file.file}.jpg`, 'photoBigger'));
            },
            covenantNames () {
                return this.formData.enrollments.map(e =>
                    Object({
                        text: e.covenantName,
                        value: e.covenantId
                    })
                );
            }
        },

        methods: {
            getAcertStatusName(statusId){
                switch(parseInt(statusId)){
                    case 6:
                        return 'DocNaoReconhecido';
                    case 5:
                        return 'Suspeito';
                    case 4:
                        return 'Automático';
                    case 3:
                        return 'Reprovado';
                    default:
                        return "Biometria";
                }
            },

            getAcertReason(statusId, reasonText, reasonId, biometryId){
                if([6,5,4,3].indexOf(parseInt(statusId)) >= 0){
                    return `${reasonText} (${reasonId})`;
                }else{
                    switch(parseInt(biometryId)){
                        case 1:
                            reasonText = 'Reconhecido';
                            break;
                        case 2:
                            reasonText = 'Não reconhecido';
                            break;
                        case 3:
                            reasonText = 'Indeterminado';
                            break;
                        case 4:
                            reasonText = 'Duvidoso';
                            break;
                        default:
                            reasonText = "Sem biometria";
                            break;
                    }
                    return `${reasonText} (${biometryId})`
                }
            }
        },
    });
</script>

<style scoped>
    .harpia, .acert {
        background-color: #f5f5f5;
        padding: 10px 17px;
        margin-bottom: 20px;
    }

    .harpia > div:first-child, .acert > div:first-child {
        display: flex;
        flex-direction: row;
        margin-bottom: 3px;
    }

    .harpia-title, .acert-title {
        margin: 0;
        color: #555555;
        font-weight: bold;
    }

    .harpia-description, .acert-description {
        margin: 0;
        margin-left: 10px;
        color: #e94343;
        font-weight: bold;
    }

    .harpia-substatus, .acert-substatus {
        margin: 0;
        background-color: white;
        border-radius: 5px;
        padding: 15px;
    }

    .harpia-substatus-description {
        margin: 0;
        font-size: 14px;
        color: #9e9e9e;
        margin-bottom: 5px;
    }

    .harpia-reasons, .acert-substatus {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 15px;
    }

    .harpia-reasons:last-child {
        margin-bottom: 0;
    }

    .harpia-reasons > i, .acert-substatus > i {
        color: #e94343;
    }

    .harpia-reasons > div, .acert-substatus > div {
        margin-left: 5px;
    }

    .harpia-reasons-description, .acert-reason {
        margin: 0;
        font-weight: bold;
        color: #555555;
    }

    .harpia-reasons-note, .acert-text-reason {
        margin: 0;
        color: #9e9e9e;
    }
</style>


// WEBPACK FOOTER //
// src/pages/PendingAppUsersForm.vue